import { render, staticRenderFns } from "./TicketDetail.vue?vue&type=template&id=2555c62e"
import script from "./TicketDetail.vue?vue&type=script&lang=js"
export * from "./TicketDetail.vue?vue&type=script&lang=js"
import style0 from "./TicketDetail.vue?vue&type=style&index=0&id=2555c62e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports